import { ThemeTypes } from '../styles';
import { useMatchMedia } from './useMatchMedia';

export const usePreferredColorScheme = () => {
  const match = useMatchMedia('(prefers-color-scheme: dark)');
  return match ? ThemeTypes.dark : ThemeTypes.light;
};
